import * as React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

interface ExpandableSettingsProps {
  children?: React.ReactNode;
  label: string;
  initializeAsExpanded: boolean;
  errors?: object;
}

export const ExpandableSettings: React.FC<ExpandableSettingsProps> = ({
  children,
  label,
  initializeAsExpanded,
  errors,
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(initializeAsExpanded);

  React.useEffect(() => {
    if (errors || initializeAsExpanded) {
      setExpanded(true);
    }
  }, [errors, initializeAsExpanded]);

  const formattedChildren = (
    <Box
      component="span"
      sx={{
        display: expanded ? "" : "none",
      }}
    >
      {children}
    </Box>
  );

  return (
    <>
      <Box
        onClick={() => setExpanded(!expanded)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            setExpanded(!expanded);
          } else if (event.key === "ArrowDown") {
            setExpanded(true);
          } else if (event.key === "ArrowUp") {
            setExpanded(false);
          }
        }}
        sx={{
          color: (theme) => {
            if (errors) {
              return theme.palette.error.main;
            } else {
              return theme.palette.primary.main;
            }
          },
          marginBottom: "20px",
          cursor: "pointer",
          display: "inline-block",
        }}
        tabIndex={0}
      >
        <Typography sx={{ display: "flex", alignContent: "center" }}>
          {label} {expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        </Typography>
      </Box>
      {formattedChildren}
    </>
  );
};
